import { EDIT_ANNOUNCEMENTS_LOADING, EDIT_ANNOUNCEMENTS_SUCCESS, EDIT_ANNOUNCEMENTS_ERROR } from "../../../constant/actionTypes";

const editAnnouncementReducer = (state = {}, action) => {
    switch (action.type) {
        case EDIT_ANNOUNCEMENTS_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }
        case EDIT_ANNOUNCEMENTS_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response.data,
            };
            return obj;
        }
        case EDIT_ANNOUNCEMENTS_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }
        default:
            return state;
    }
}

export default editAnnouncementReducer;